import { Variant } from '../types';

export const forwarderExport: Variant = {
  'messageInfo.methodOfPayment': { present: false },
  'messageInfo.deferredPayment': { present: false },
  'messageInfo.methodOfPaymentVAT': { present: false },
};
